import {LEGAL_ENTITIES, LEGAL_ENTITY} from "~/constants/api/payment/payment";

export async function getLegalEntities() {
    return await useApi(`${LEGAL_ENTITIES}`, 'GET');
}

export async function createLegalEntities(data:LegalEntities) {
    return await useApi(`${LEGAL_ENTITIES}`, 'POST', data)
}

export async function updateLegalEntities( id:string,data:LegalEntities) {
    return await useApi(`${LEGAL_ENTITY.replace(':id',id)}`,'PATCH', data)
}

export async function deleteLegalEntities(id:string) {
    return await useApi(`${LEGAL_ENTITY.replace(':id',id)}`,'DELETE',{})
}